import { render, staticRenderFns } from "./Unconfirmed.vue?vue&type=template&id=1f6d9fda&scoped=true&"
import script from "./Unconfirmed.vue?vue&type=script&lang=js&"
export * from "./Unconfirmed.vue?vue&type=script&lang=js&"
import style0 from "./Unconfirmed.vue?vue&type=style&index=0&id=1f6d9fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d9fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
